import Layout from "layouts";

import { Fragment, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { IPolicyView } from "api/policy/types";
import { fetchPolicied, fetchPolicy } from "api/policy/rests";

const PolicyPage = () => {
  const [searchParams] = useSearchParams();

  const policyId = searchParams.get("policy_id")
    ? parseInt(searchParams.get("policy_id")!)
    : undefined;
  const category = searchParams.get("category");
  const type = searchParams.get("type");
  const title = searchParams.get("title");
  const noHeader = searchParams.get("noheader") === "true";

  const [policy, setPolicy] = useState<IPolicyView>();

  const navigate = useNavigate();

  useEffect(() => {
    if (category || type) {
      (async () => {
        const { data } = await fetchPolicied(category, type);
        setPolicy(
          (policyId && data.find((item) => item.policy_id === policyId)) ||
            (title && data.find((item) => item.title === title)) ||
            data.sort((a, b) => b.policy_id - a.policy_id)[0]
        );
      })();
    } else if (policyId) {
      (async () => {
        const { data } = await fetchPolicy(Number(policyId));
        setPolicy(data);
      })();
    } else {
      navigate("/", { replace: true });
    }
  }, [policyId, category, type]);

  return (
    <Layout extraClass="bg-grey" excludeHeader={noHeader}>
      {/* <Banner /> */}

      <section className="join policy">
        <div className="inner wrap">
          <div className="intro-txt-box">{policy?.title}</div>

          <div
            className="txt-box"
            dangerouslySetInnerHTML={{ __html: policy?.contents || "" }}
          >
            {/* {policy?.contents.split("\n").map((row, i) => (
              <Fragment key={i}>
                {row}
                <br />
              </Fragment>
            ))} */}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolicyPage;
